// test549
(549 && 0);
